import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Rankings from './pages/Rankings';
import ServerRankings from './pages/ServerRankings';
import PlayerProfile from './pages/PlayerProfile';
import Download from './pages/Download';
import { useLocation } from 'react-router-dom';
import './index.css';
import { Analytics } from '@vercel/analytics/react';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-mc-darker">
        <ScrollToTop />
        <Navbar />
        <main className="container mx-auto px-4 py-8 max-w-6xl">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/rankings" element={<Rankings />} />
            <Route path="/servers" element={<ServerRankings />} />
            <Route path="/player/:username" element={<PlayerProfile />} />
            <Route path="/download" element={<Download />} />
          </Routes>
        </main>
        <footer className="text-center text-mc-muted text-sm py-6 border-t border-mc-border">
          <p>⛏️ OnStats Portal — Minecraft Mining Tracker</p>
        </footer>
      </div>
    <Analytics />
    </Router>
  );
}

export default App;
